<template>
  <li>
    <div
      class="treeview__level"
      :class="bgClass"
      :data-level="node.title && node.title[0]"
    >
      <input
        v-if="isEditing"
        ref="editTitle"
        v-model="updates.title"
        @keypress.enter="saveEditing"
        @keyup.esc="cancelEditing"
        class="edit-title level-title"
      />
      <span
        v-else
        class="level-title"
        :class="isSelected ? 'blue': ''"
        @click="isSelected=!isSelected"
        @dblclick="startEditing"
        @keypress.tab="ignore++"
        @keyup.right="isExpanded=false"
        @keyup.down="isExpanded=true"
      >
        {{ `${isRoot ? '' : node.order + 1} ${node.title}` }}
      </span>

      <div class="treeview__level-btns">
        <div v-if="isEditing" class="btn btn-edit btn-sm">
          <button class="fa-icon" @click="saveEditing">
            <fa-icon icon="fas fa-square-check" class="info" />
          </button>
          <button class="fa-icon" @click="cancelEditing">
            <fa-icon icon="fas fa-times-square" class="text-danger" />
          </button>
        </div>
        <div v-else-if="isSelected" class="btn btn-default btn-sm">
          <button class="fa-icon" @click="startEditing">
            <fa-icon icon="fas fa-pencil" class="info" />
          </button>
          <button v-if="!isRoot" class="fa-icon" @click="removeMe">
            <fa-icon icon="fas fa-trash" class="text-danger" />
          </button>
        </div>
        <div v-else>
          <button class="fa-icon" v-if="canUp" @click="$emit('up')">
            <fa-icon icon="fas fa-arrow-up" />
          </button>
          <button class="fa-icon" v-if="canDown" @click="$emit('down')">
            <fa-icon icon="fas fa-arrow-down" />
          </button>
        </div>
        <button class="fa-icon inline-block" @click="toggle">
          <fa-icon icon="fas fa-angle-right" :rotation="isExpanded ? 90 : null" />
        </button>
        <div class="btn btn-default btn-sm level-add">
        </div>
      </div>
    </div>
    <ul v-if="isExpanded">
      <tree-node-2
        v-for="(item, index) in node.leafs"
        :key="item.id"
        :node="item"
        :level="item.id"
        :can-up="index > 0"
        :can-down="index < (node.leafs.length - 1)"
        @up="node.up(item.order)"
        @down="node.down(item.order)"
        @change-name="$emit('change-name', $event)"
        @make-folder="$emit('make-folder', $event)"
        @add-item="$emit('add-item', $event)"
        @remove-item="removeChild(item.id)"
        @removeChild="relayRemoveChild"
      />
      <li>
        <button @click="addChild">
          <fa-icon icon="fas fa-plus-square" />
        </button>
      </li>
    </ul>
  </li>
</template>

<script>
const SUPPORTED_BG_COLOR = 12;

export default {
  props: {
    level: Number,
    node: Object,
    isRoot: Boolean,
    canUp: Boolean,
    canDown: Boolean,
  },
  data() {
    return {
      ignore: 0,
      isExpanded: false,
      isSelected: false,
      isEditing: false,
      updates: {
        title: '',
      },
    };
  },
  computed: {
    bgClass() {
      return `bg-${this.level % SUPPORTED_BG_COLOR}`;
    },
    nextLevel() {
      return Number(this.level) + 1;
    },
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    startEditing() {
      this.updates.title = this.node.title;
      this.isEditing = true;
      this.$nextTick(() => {
        if (this.$refs.editTittle) this.$refs.editTittle.focus();
      });
    },
    saveEditing() {
      this.$emit('change-name', [this.node, this.updates.title]);
      this.isEditing = false;
      this.isSelected = false;
    },
    cancelEditing() {
      this.isEditing = false;
    },
    makeFolder() {
      if (!this.isFolder) {
        this.$emit('make-folder', this.node);
        this.isOpen = true;
      }
    },
    addChild() {
      this.$emit('add-item', this.node);
    },
    removeMe() {
      this.$emit('remove-item');
    },
    removeChild(childIndex) {
      this.$emit('remove-child', this.node, childIndex);
    },
    relayRemoveChild(node, leafId) {
      // eslint-disable-next-line no-param-reassign
      node.leafs = node.leafs.filter((leaf) => leaf.id !== leafId);
    },
  },
};
</script>

/* eslint-disable */
<style lang="scss">
$bgcs: (1: 'bada55', 2: '00FF00', 3: '808000', 4: '6d6d55', 5: 'FF00FF',
        6: '00FFFF', 7: '008080', 8: '000080', 9: '008000', 10: '005757',
        11: '00a8a8', 12: 'dec8ab');
@each $i, $code in $bgcs {
  .treeview__level.bg-#{$i}:before{
    background-color: #{"#"}#{$code};
  }
}
</style>
<style>
.text-danger {
  color: red;
}
.hover-only {
  opacity: 0;
}
.treeview-level:hover .hover-only {
  opacity: 1;
}
.blue {
  color: blue;
}
.fa-icon + .fa-icon {
  padding-left: 1em;
}
.inline-block {
  display: inline-block;
}
button.fa-icon {
  padding: 4px 10px;
}
</style>
/* eslint-enable */
